import { components, operations } from "types/openapi";

export type ContractEntity = components["schemas"]["ContractCardDto"] & {
  counterpartyLegalAddress?: string;
  counterpartyActualAddress?: string;
};
export type ContractGridDto = components["schemas"]["ContractGridDto"];
export type NetworkType = components["schemas"]["RequestCardDto"]["network"];
export type DirectionType = components["schemas"]["ContractDto"]["direction"];
export type CurrencyType = components["schemas"]["RequestCardDto"]["currency"];
export type FiatCurrency = components["schemas"]["CreateContractRequest"]["fiatCurrency"];
export type OperationType = operations["generateCode"]["parameters"]["path"]["action"];
export type CreateContractRequest = components["schemas"]["CreateContractRequest"];
export type ContractOnCompany = components["schemas"]["PageContractByCompanyGridDto"]["content"];
export type UserOnCompany = components["schemas"]["PageUserDto"]["content"];
export type GlobalBalanceDto = components["schemas"]["GlobalBalanceDto"];
export type CountryCodeGridDto = components["schemas"]["OksmDto"];
export type FiatCurrencyGridDto = components["schemas"]["CurrencyCodeDto"];
export type ExpandNetworkType = Exclude<NetworkType, undefined>;
export type UnkValidationResponse = components["schemas"]["UnkValidationResponse"];

export const NETWORK_TEXT: Record<ExpandNetworkType, string> = {
  ETH: "Ethereum (ERC-20)",
  TRX: "Tron (TRC-20)",
};

export const NETWORK_TEXT_WITHOUT_STANDARD: Record<ExpandNetworkType, string> = {
  ETH: "Ethereum",
  TRX: "Tron",
};

export const DIRECTION_TEXT: Record<DirectionType, string> = {
  IMP: "Импорт",
  EXP: "Экспорт",
};

export const OPERATION_TYPE = {
  LOGIN: "LOGIN",
  PASSWORD: "PASSWORD",
  QUOTE_CREATE: "QUOTE_CREATE",
  REQUEST_CREATE: "REQUEST_CREATE",
  REQUEST_APPROVE: "REQUEST_APPROVE",
  BANK_TRANSFER_SENT: "BANK_TRANSFER_SENT",
  BANK_TRANSFER_RECEIVED: "BANK_TRANSFER_RECEIVED",
  INITIATE_WITHDRAWAL: "INITIATE_WITHDRAWAL",
  BANK_TRANSFER_RECEIVED_BY_PLATFORM: "BANK_TRANSFER_RECEIVED_BY_PLATFORM",
  BANK_TRANSFER_WITHDRAWN: "BANK_TRANSFER_WITHDRAWN",
  RUB_WITHDRAWAL_REQUEST: "RUB_WITHDRAWAL_REQUEST",
  CUSTOMER_EXECUTION: "CUSTOMER_EXECUTION",
  VERIFY_WALLET_REQUEST: "VERIFY_WALLET_REQUEST",
  VERIFY_WALLET_QUOTE: "VERIFY_WALLET_QUOTE",
  NOMINAL_ACCOUNT_DEPOSIT: "NOMINAL_ACCOUNT_DEPOSIT",
} as const;

type CheckOperationKeysMatch = OperationType extends keyof typeof OPERATION_TYPE ? true : false;
export const checkOperationsKeys: CheckOperationKeysMatch = true;

export enum CONTRACT_CURRENCY_ENUM {
  USDT = "USDT",
  USDC = "USDC",
}

export enum TOKEN_BALANCE_ENUM {
  USDT = "USDT",
  USDC = "USDC",
  ETH = "ETH",
  RUB = "RUB",
  TRX = "TRX",
}

export const contractCurrencyName: Record<TOKEN_BALANCE_ENUM, string> = {
  USDT: "Tether",
  USDC: "USDC",
  ETH: "ETH",
  RUB: "RUB",
  TRX: "TRX",
};

type CheckCurrencyKeysMatch =
  Exclude<CurrencyType, undefined> extends keyof typeof CONTRACT_CURRENCY_ENUM ? true : false;
export const checkCurrencyKeys: CheckCurrencyKeysMatch = true;

export const FIAT_CURRENCY_ENUM = {
  USD: "USD",
  CNY: "CNY",
  RUB: "RUB",
  EUR: "EUR",
} as const;

export const BALANCE_FILTERS_TITLE: Record<TOKEN_BALANCE_ENUM, string> = {
  RUB: "Российский рубль",
  USDT: "Tether",
  USDC: "USDC",
  TRX: "TRON",
  ETH: "Ethereum",
} as const;

export enum NATIVE_TOKENS_ENUM {
  ETH = "ETH",
  TRX = "TRX",
}

export enum CONTRACT_ADDRESS_TYPE {
  LEGAL = "counterpartyLegalAddress",
  ACTUAL = "counterpartyActualAddress",
}

export enum CONTRACT_BLOCK_ACTION_MODE {
  BLOCK = "block",
  UNBLOCK = "unblock",
}
